// File for miscellaneous type definitions local to subtree
export enum AnnotationColors {
  DEFAULT = "black",
  SELECTED = "blue",
  ACTIVE = "black",
  DIAGNOSTIC = "red",
}
